import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { actions as accountActions } from '../../reducers/Account';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import ReviewSignupHeader from '../../components/ReviewSignupHeader';
import LandingPage from '../ReviewerOnboarding/LandingPage';
import ReviewerEmailVerificationStep from '../ReviewerOnboarding/EmailVerificationStep';
import ReviewerSignUpProfile from '../ReviewerSignUpProfile';
import { Div } from 'Common/components/Atoms/Div';

interface Props {
  fetchAccount: () => void;
  match: {
    path: string;
  };
}

class ReviewerSignUpRoute extends Component<Props> {
  componentDidMount() {
    this.props.fetchAccount();
  }

  render() {
    const { match } = this.props;
    return (
      <Div height="100%">
        <ReviewSignupHeader />
        <Div>
          <Switch>
            <Route exact path={match.path} component={LandingPage} />
            <Route
              path={`${match.path}/verification`}
              exact
              component={ReviewerEmailVerificationStep}
            />
            <Route
              exact
              path={`${match.path}/profile`}
              component={ReviewerSignUpProfile}
            />
            <Redirect to="/reviewer" />
          </Switch>
        </Div>
      </Div>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(accountActions, dispatch);
}

export default connect(null, mapDispatchToProps)(ReviewerSignUpRoute);
